export var TriggerViewMode;
(function (TriggerViewMode) {
    TriggerViewMode["popup"] = "popup";
    TriggerViewMode["drawer"] = "drawer";
    TriggerViewMode["modal"] = "modal";
})(TriggerViewMode || (TriggerViewMode = {}));
